/* Indirookh product page: price shown without trailing .00, plus a tax note.
   The theme re-renders the price on every variant change, so this re-applies on change. */
(function () {
  var box = document.getElementById('product-price');
  if (!box) return;
  function tidy() {
    box.querySelectorAll('[data-regular-price],[data-sale-price]').forEach(function (el) {
      var t = el.textContent, n = t.replace(/\.00(?!\d)/, '');
      if (n !== t) el.textContent = n.trim();
    });
    if (!box.parentNode.querySelector('.ir-tax')) {
      var d = document.createElement('div');
      d.className = 'ir-tax';
      d.textContent = 'Inclusive of all taxes';
      box.insertAdjacentElement('afterend', d);
    }
  }
  tidy();
  new MutationObserver(tidy).observe(box, { childList: true, subtree: true, characterData: true });

  // Essential sticky add-to-cart bar renders later and re-renders on variant change
  function tidyText(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (/\d\.00(?!\d)/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/(\d)\.00(?!\d)/g, '$1');
    }
  }
  var tries = 0, watching = false;
  var t = setInterval(function () {
    var bar = document.querySelector('[data-essential-cart-element="essential-sticky-cart-container"]');
    if (bar && !watching) {
      watching = true; tidyText(bar);
      new MutationObserver(function () { tidyText(bar); }).observe(bar, { childList: true, subtree: true, characterData: true });
    }
    if (watching || ++tries > 40) clearInterval(t);
  }, 250);
})();

/* Details / Returns / Shipping tabs -> folding sections (first one open). */
(function () {
  function build() {
    var cont = document.querySelector('.js-tabbed-product-container');
    if (!cont || cont.classList.contains('ir-acc-ready')) return;
    var links = Array.prototype.slice.call(cont.querySelectorAll('.product__tabs a.js-tab-trigger'));
    if (!links.length) return;
    var acc = document.createElement('div');
    acc.className = 'ir-acc';
    links.forEach(function (a, i) {
      var panel = document.getElementById(a.getAttribute('data-content') || '');
      if (!panel) return;
      var d = document.createElement('details');
      if (i === 0) d.open = true;
      var s = document.createElement('summary');
      s.textContent = a.textContent.trim();
      d.appendChild(s);
      d.appendChild(panel);
      acc.appendChild(d);
    });
    if (!acc.children.length) return;
    cont.appendChild(acc);
    cont.classList.add('ir-acc-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();


/* Product gallery: photos after the opening one carry data-ir-src (snippets/product-image-gallery).
   The theme rebuilds the visible gallery per colour, so cells are read fresh on every change:
   the selected slide and its two neighbours get their real image. */
(function () {
  function load(c) {
    if (!c) return;
    c.querySelectorAll('img[data-ir-src]').forEach(function (i) {
      if (i.dataset.irSrcset) i.srcset = i.dataset.irSrcset;
      i.src = i.dataset.irSrc;
      i.removeAttribute('data-ir-src'); i.removeAttribute('data-ir-srcset');
    });
  }
  function sweep() {
    document.querySelectorAll('.js-carousel-main').forEach(function (main) {
      var cells = main.querySelectorAll('.js-main-carousel-cell'), n = cells.length;
      for (var k = 0; k < n; k++) {
        if (cells[k].classList.contains('is-selected')) {
          load(cells[k]); load(cells[(k + 1) % n]); load(cells[(k - 1 + n) % n]);
        }
      }
    });
  }
  var queued = false;
  function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; sweep(); }); }
  function start() {
    if (!document.querySelector('img[data-ir-src]')) return;
    var root = document.querySelector('.js-product-gallery') || document.body;
    new MutationObserver(queue).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    sweep();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
